import React, { useMemo } from 'react';
import {
  transformFilterMetaToFields,
  FilterRulesBuilder,
  getDefaultField,
  type Query,
} from '@components/filter/components/common/FilterRulesBuilder';
import * as Styled from './styled';
import { disabledOperators, DataSource } from '@components/filter/components/utils';
import { useDrilldownLimit } from 'components/filter/components/Management/hooks';
import * as Types from '@components/filter/types';

interface Props {
  id?: string;
  showError?: boolean;
  filterMeta: Types.FilterMeta;
  dataSource: DataSource;
  value?: Query;
  onChange?: (value: Query) => void;
}

const AdvanceFilterBuilder = (props: Props) => {
  const { id, filterMeta, dataSource, value, showError, onChange } = props;
  const drilldownLimit = useDrilldownLimit(dataSource);

  const fields = useMemo(
    () => transformFilterMetaToFields(filterMeta, { disabledOperators }),
    [filterMeta],
  );

  const defaultField = getDefaultField(fields, dataSource);

  const handleChange = (q: Query) => {
    onChange?.(q);
  };

  return (
    <Styled.AdvanceFilterBuilderContainer id={id}>
      <FilterRulesBuilder
        className="filter-rule-builder-container"
        dataSource={dataSource}
        showError={showError}
        initialField={defaultField}
        fields={fields}
        query={value!}
        drilldownLimit={drilldownLimit}
        disabledOperators={disabledOperators}
        onChange={handleChange}
      />
    </Styled.AdvanceFilterBuilderContainer>
  );
};

export default React.memo(AdvanceFilterBuilder);
